import { render, staticRenderFns } from "./server_administration_component.vue?vue&type=template&id=4a50f910&scoped=true&"
import script from "./server_administration_component.vue?vue&type=script&lang=js&"
export * from "./server_administration_component.vue?vue&type=script&lang=js&"
import style0 from "./server_administration_component.vue?vue&type=style&index=0&id=4a50f910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50f910",
  null
  
)

export default component.exports